import { ASSETS } from '../../assets';

export const CARDS = [
    { key: 'ambition', images: [ASSETS.valuesImg1, ASSETS.valuesImg2] },
    { key: 'commitment', images: [ASSETS.valuesImg3, ASSETS.valuesImg4] },
    { key: 'future', images: [ASSETS.valuesImg5, ASSETS.valuesImg6] },
] as const;
